import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function WhatYouGetStack() {
  const items = [{
    title: 'Ebook Principal',
    desc: 'La guía completa de 30 días de reprogramación interna. Protocolo diario paso a paso, ejercicios de regulación somática, técnicas de neuroplasticidad aplicada.',
    value: 57,
    icon: '📗',
    img: 'https://cdn.magicpatterns.com/uploads/kKADeGZJMEeGSeR67ZnTwY/ChatGPT_Image_4_may_2026,_08_42_56_p.m..png'
  }, {
    title: 'Checklist Integral',
    desc: 'Lista de implementación simple para que nunca te pierdas. Seguimiento visual de tu progreso día a día.',
    value: 17,
    icon: '✅',
    img: 'https://cdn.magicpatterns.com/uploads/cNayor6oo1GwcU42RupKh9/Bono_1..png'
  }, {
    title: 'Mapa Personal',
    desc: 'Tu hoja de ruta personalizada de regulación interna. Identifica tus patrones únicos y cómo transformarlos.',
    value: 27,
    icon: '🗺️',
    img: 'https://cdn.magicpatterns.com/uploads/wmSKT8CWghiPfTLs91xv7c/4._Oferta.png'
  }];
  return <section className="py-24 px-4 bg-beige-dark/20" data-id="element-290">
      <div className="max-w-4xl mx-auto" data-id="element-291">
        <div className="text-center mb-16" data-id="element-292">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-teal mb-4" data-id="element-293">
            Todo lo que obtienes hoy:
          </h2>
        </div>

        <div className="space-y-6" data-id="element-294">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-5 sm:p-6 md:p-8 shadow-sm border border-sage/20 flex flex-col md:flex-row items-center gap-5 md:gap-8" data-id="element-295">
              <div className="w-2/3 sm:w-1/2 md:w-1/3 aspect-[3/4] rounded-xl overflow-hidden bg-beige relative shrink-0" data-id="element-296">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover opacity-90 mix-blend-multiply" data-id="element-297" />
                <div className="absolute inset-0 bg-gradient-to-t from-teal/80 to-transparent flex items-end p-4" data-id="element-298">
                  <div className="text-4xl" data-id="element-299">{item.icon}</div>
                </div>
              </div>

              <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-300">
                <div className="flex items-center justify-center md:justify-between mb-3 flex-wrap gap-2" data-id="element-301">
                  <h3 className="font-heading font-bold text-xl sm:text-2xl text-teal break-words" data-id="element-302">
                    {item.title}
                  </h3>
                  <div className="bg-gold/10 text-teal text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-lg border border-gold/30 whitespace-nowrap" data-id="element-303">
                    Valor:{' '}
                    <PriceDisplay amountUSD={item.value} className="line-through text-gold-dark ml-1" data-id="element-304" />
                  </div>
                </div>
                <p className="text-neutral-gray font-sans leading-relaxed text-sm sm:text-base" data-id="element-305">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}